import service from "@/store/services/categories-service";

export const state = () => ({
  list: {},
  category: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, category) => {
    state.category = category;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((category) => {
      commit("SET_RESOURCE", category);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((category) => {
      commit("SET_RESOURCE", category);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((category) => {
      commit("SET_RESOURCE", category);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },

  activate({ commit, dispatch }, params) {
    return service.activate(params, this.$axios).then((category) => {
      commit("SET_RESOURCE", category);
    });
  },

  deactivate({ commit, dispatch }, params) {
    return service.deactivate(params, this.$axios).then((category) => {
      commit("SET_RESOURCE", category);
    });
  },

  applyConfiguration({ commit, dispatch }, params) {
    return service.applyConfiguration(params, this.$axios).then((data) => {
      commit("SET_RESOURCE", data);
      return data;
    });
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  category: (state) => state.category,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((category) => ({
      id: category.id,
      name: `${category.name}`,
    }));
  },
};

const categories = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default categories;
